export const COMPANY = {
  name: "Apex Precitech",
  tagline: "Precision Instruments for Textile Spinning Excellence",
  phone: "+91 98430 35014",
  phoneRaw: "919843035014",
  email: "apexpreci@gmail.com",
  whatsapp: "https://wa.me/919843035014?text=Hi%20Apex%20Precitech%2C%20I%20would%20like%20to%20get%20a%20quote.",
  blog: "https://apexprecitech.wordpress.com/",
  address: "Coimbatore, Tamil Nadu, India",
  founded: 1996,
};

export const BRANDS = [
  "Rieter", "Lakshmi", "Trutzschler", "Marzoli", "Suessen", "Toyota", "Rotorcraft"
];

export const MILESTONES = [
  { year: "1996", text: "Founded & First Top Arm Load Gauge shipped — direct reading in kilograms, a first for the industry" },
  { year: "2000", text: "International exports begin — instruments reach mills across 15+ countries" },
  { year: "2008", text: "1,000+ mills using Apex instruments for drafting load measurement" },
  { year: "2013", text: "World's first Ring Spindle Concentricity Setting Device for stationary spindles launched" },
  { year: "2018", text: "5,000+ mills worldwide trust Apex instruments for yarn quality" },
  { year: "2026", text: "Digital Top Arm Load Gauge, Dew Point Indicator & Prasiddhi Compact Attachment launched" },
];

export const ARTICLES = [
  { title: "Working Principle of the P 3-1 Top Arm", tag: "Technical Deep Dive", excerpt: "Construction, load distribution, and why this pneumatic top arm has dominated ring spinning for 25+ years." },
  { title: "Energy Consumed in Pneumatic Drafting", tag: "Research", excerpt: "Power consumed by excess drafting loads in P3-1 systems — with cost calculations for a 25,000-spindle mill." },
  { title: "Suessen Elite Compact Spinning & Load Setting", tag: "Application Guide", excerpt: "Optimising drafting load measurement in the Suessen Elite compact spinning system." },
  { title: "Texparts PK 2025 Top Arm & Apex Load Gauge", tag: "Machine Guide", excerpt: "Measuring and adjusting loads on the widely-used Texparts PK 2025 top arm." },
  { title: "Lakshmi Rieter P 3-1 Loading Details", tag: "Loading Chart", excerpt: "Complete loading specifications and measurement procedures for the P 3-1 top arm." },
  { title: "RoCoS Compact Spinning & Apex Gauges", tag: "Application Guide", excerpt: "How Apex gauges integrate with the RoCoS compact spinning system." },
  { title: "Load Equalization System for Ring Frames", tag: "Innovation", excerpt: "Eliminating back roller buffing and reducing imperfections by ~15% in carded counts and synthetic yarns." },
  { title: "Apex Wing Cradle for Ring Frames", tag: "Innovation", excerpt: "Spring-loaded cradle with tangential tightening for uniform apron tension and reduced imperfections." },
  { title: "Draw Frame Gauge for Wet Linen/Flax", tag: "Speciality", excerpt: "Custom electronic load measurement device for vintage flax draw frames with 300mm bamboo rollers." },
];

export const STATS = [
  { value: 30, suffix: "+", label: "Years of Excellence" },
  { value: 5000, suffix: "+", label: "Mills Worldwide" },
  { value: 18, suffix: "+", label: "Countries Exported" },
  { value: 9, suffix: "", label: "Precision Instruments" },
];

export const HERO_IMAGES = {
  main: "https://images.unsplash.com/photo-1760818072388-4604d5cb39ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  machinery: "https://images.unsplash.com/photo-1522753071498-f3137a65aee3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  factory: "https://images.unsplash.com/photo-1682253398724-d1cfe17f4607?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
};
